import { Auth } from '@aws-amplify/auth';

import TokensBroker from '../../features/authentication/services/TokensBroker';

/**
 * Wraps a promise with a timeout that resolves after the specified time
 * @returns Promise that resolves with the original promise result or void if timeout occurs
 */
async function withTimeout<T>(
  promise: Promise<T>,
  timeoutMs: number,
): Promise<T | void> {
  const timeoutPromise = new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, timeoutMs);
  });

  return Promise.race([promise, timeoutPromise]);
}

export async function authenticationLoader() {
  let authenticated = false;

  try {
    await Auth.currentSession();
    authenticated = true;
  } catch {
    authenticated = false;
  }

  if (!authenticated) {
    const tokensBroker = new TokensBroker();
    await withTimeout(tokensBroker.waitForTokens(), 1000);
  }

  return null;
}
